import { render, staticRenderFns } from "./TableStoreDetailLog.vue?vue&type=template&id=90de6972&"
import script from "./TableStoreDetailLog.vue?vue&type=script&lang=js&"
export * from "./TableStoreDetailLog.vue?vue&type=script&lang=js&"
import style0 from "./TableStoreDetailLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDataTable,VDialog,VImg})
